/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Login_GenericInputs */

const en_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login failed. Please try again.`)
};

const de_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung fehlgeschlagen. Bitte versuch es erneut.`)
};

const fr_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion échouée. Réessaie.`)
};

const es_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de inicio de sesión. Por favor, inténtelo de nuevo.`)
};

const it_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso non riuscito. Riprova.`)
};

const nl_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen mislukt. Probeer het opnieuw.`)
};

const pl_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie nie powiodło się. Spróbuj ponownie.`)
};

const fi_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjautuminen epäonnistui. Yritä uudelleen.`)
};

const da_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login mislykkedes. Prøv igen.`)
};

const sv_auth_error_login_generic = /** @type {(inputs: Auth_Error_Login_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggning misslyckades. Försök igen.`)
};

/**
* | output |
* | --- |
* | "Login failed. Please try again." |
*
* @param {Auth_Error_Login_GenericInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_error_login_generic = /** @type {((inputs?: Auth_Error_Login_GenericInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Login_GenericInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_error_login_generic(inputs)
	if (locale === "fr") return fr_auth_error_login_generic(inputs)
	if (locale === "es") return es_auth_error_login_generic(inputs)
	if (locale === "it") return it_auth_error_login_generic(inputs)
	if (locale === "nl") return nl_auth_error_login_generic(inputs)
	if (locale === "pl") return pl_auth_error_login_generic(inputs)
	if (locale === "fi") return fi_auth_error_login_generic(inputs)
	if (locale === "da") return da_auth_error_login_generic(inputs)
	if (locale === "sv") return sv_auth_error_login_generic(inputs)
	return en_auth_error_login_generic(inputs)
});